/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import applyListingProductsToState from './helpers/applyListingProductsToState';

export const stageListingProductsFromCreateDraft = createAction(
  'products/stageListingProductsFromCreateDraft',
);

export const reducer = (builder) => {
  builder.addCase(stageListingProductsFromCreateDraft, (state, { payload }) => {
    applyListingProductsToState(state, payload);
  });
};
